import { ASSETS, HOST } from "@/data/content";

export default function HostPortrait() {
  return (
    <div
      data-testid="host-portrait-panel"
      className="host-portrait relative w-full overflow-hidden bg-[#0c0c0c] border border-white/10"
      style={{ aspectRatio: "4/5" }}
    >
      <span className="reg-mark" style={{ top: 10, left: 10 }} />
      <span className="reg-mark" style={{ top: 10, right: 10 }} />
      <span className="reg-mark" style={{ bottom: 10, left: 10 }} />
      <span className="reg-mark" style={{ bottom: 10, right: 10 }} />
      <img src={ASSETS.headshot} alt={HOST.name} className="absolute inset-0 w-full h-full object-cover object-top" data-testid="host-headshot" />
      <div className="absolute inset-x-0 bottom-0 h-32" style={{ background: "linear-gradient(180deg, transparent, rgba(8,8,8,0.92))" }} />
      <div className="absolute bottom-4 left-0 right-0 text-center">
        <p className="font-bold text-sm text-[#F0ECE4]">{HOST.name}</p>
        <p className="mt-1 font-mono text-[10px] tracking-[0.25em] text-[#D9622B]">RETIRED ARMY · NMLS# {HOST.nmls}</p>
      </div>
    </div>
  );
}
